// Polyfill require IE 9+
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollX
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
// See also https://github.com/Financial-Times/polyfill-library/blob/master/polyfills/~viewport/polyfill.js
var supportDescriptors = require('core-js/internals/descriptors');
var defineProperties = require('core-js/internals/object-define-properties');
var proto = Window.prototype;

if (supportDescriptors && !window.hasOwnProperty('scrollX')) {
  defineProperties(proto, {
    "scrollX": {
      configurable: true,
      get: function () {
        return this.pageXOffset;
      }
    },
    "scrollY": {
      configurable: true,
      get: function () {
        return this.pageYOffset;
      }
    },
  });
}
